function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.75 23.263l2.37-2.729m20.13 2.729l-2.37-2.729m.87-11.521c0 4.971-3.537 12.75-9.75 12.75s-9.75-7.779-9.75-12.75S5.787.763 12 .763s9.75 3.279 9.75 8.25z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 21.763a7.978 7.978 0 005.944-2.863c-.4-2.2-2.908-3.886-5.944-3.886S6.455 16.7 6.056 18.9A7.978 7.978 0 0012 21.763zm3.75-16.5h-7.5a2.25 2.25 0 000 4.5h7.5a2.25 2.25 0 000-4.5z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgRailroadMetro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgRailroadMetro;